export default __webpack_public_path__ + "media/images/images/datatables/images/sort_desc_disabled-07c018ae0160704a329067ec7fbdc614.png";